import { render, staticRenderFns } from "./KoreanSpecialLsports.vue?vue&type=template&id=23bcc36c&scoped=true"
import script from "./KoreanSpecialLsports.vue?vue&type=script&lang=js"
export * from "./KoreanSpecialLsports.vue?vue&type=script&lang=js"
import style0 from "./KoreanSpecialLsports.vue?vue&type=style&index=0&id=23bcc36c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bcc36c",
  null
  
)

export default component.exports